import React from 'react'

import "bootstrap-icons/font/bootstrap-icons.css";

import SimpleProcess from './SimpleProcess'
import EligibilitySlider from './EligibilitySlider'
import LoanCalculator from './LoanCalculator'


 const whyChoose = [
  { icon: "bi-percent", text: "Competitive Interest Rates" },
  { icon: "bi-lightning-charge", text: "Fast Approval Process" },
  { icon: "bi-file-earmark-check", text: "Minimal Documentation" },
  { icon: "bi-calendar-check", text: "Flexible EMI Options" },
  { icon: "bi-cash-stack", text: "Loan Amount as per Eligibility" },
  { icon: "bi-headset", text: "Dedicated Customer Support" },
];

const loanFeatures = [
  { icon: "bi-currency-rupee", text: "Loan Amount: As per eligibility" },
  { icon: "bi-clock-history", text: "Flexible Tenure: Up to 30 years" },
  { icon: "bi-lightning", text: "Quick Disbursal" },
  { icon: "bi-arrow-left-right", text: "Balance Transfer Facility Available" },
  { icon: "bi-shield-check", text: "Transparent Processing" },
];
 

const HomeLoan = () => {
  return (
    <div>
      <section className="welcome_area home" id="home">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">
                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge"> Home Loan</p>
                    </div>
                    <span className="integration-text">
                      Simple, fast and transparent home financing
                    </span>
                  </div>
                </div>
                <h1 className="b-text bold">
                  Turn Your Dream Home Into Reality with Me Loans
                </h1>
                <p>
                  Affordable home loans with quick approval, low interest rates, and flexible repayment options
                </p>
                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="contact.html" className="btn more-btn mr-3">
                    Contact us
                  </a>
                  <a className="btn more-btn" href="services.html">
                    Apply For Loan
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6"></div>
          </div>
        </div>
      </section>

      <section className="about-us-area section-padding-100 clearfix">
        <div className="container-fluid">
          <div className="row align-items-center">

            <div className="col-12 col-lg-6 offset-lg-0 col-md-12  ">
              <div className="welcome-meter fadeInUp" data-wow-delay="0.7s">
                <img draggable="false" src="image/home.png" alt="" />
              </div>
            </div>

            <div className="col-12 col-lg-6 offset-lg-0 col-md-10 offset-md-1">
              <div className="who-we-contant mt-s">
                 
                <h4 className="fadeInUp" data-wow-delay="0.3s">
                  Why Choose Me Loans for Your Home Loan?
                </h4>
                <p className="fadeInUp" data-wow-delay="0.4s">
                  At Me Loans, we understand that owning a home is one of life’s biggest milestones. That’s why we offer simple, transparent, and hassle-free home loan solutions tailored to your needs.
                </p>
                <p className="fadeInUp" data-wow-delay="0.5s">
                  Whether you're purchasing a new home, constructing a house, or refinancing an existing loan, we help you every step of the way.
                </p>
                <a
                  className="btn more-btn mt-30 fadeInUp"
                  data-wow-delay="0.6s"
                  href="/apply-for-loan"
                >
                  Apply For Loan
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
      <div className="container">

        {/* Why Choose Section */}
        <div className="text-center mb-5">
          <h2 className="fw-bold  ">
            Why Choose Me Loans for Home Loan?
          </h2>
        </div>

        <div className="row g-4 mb-5">
          {whyChoose.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="feature-box shadow-sm p-4 bg-white rounded h-100 d-flex align-items-center">
                <i className={`bi ${item.icon} feature-icon me-3`}></i>
                <h6 className="mb-0">{item.text}</h6>
              </div>
            </div>
          ))}
        </div>

        {/* Loan Features Section */}
        <div className="text-center mb-4">
          <h3 className="fw-bold text-secondary">Loan Features</h3>
        </div>

        <div className="row g-4">
          {loanFeatures.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="feature-box shadow-sm p-4 bg-white rounded h-100 d-flex align-items-center">
                <i className={`bi ${item.icon} feature-icon me-3`}></i>
                <h6 className="mb-0">{item.text}</h6>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Internal Styling */}
      <style>{`
        .feature-box {
          transition: 0.3s ease;
          padding: 20px;
        }
          .col-md-6.col-lg-4 {
          padding: 6px
          }

        .feature-box:hover {
          transform: translateY(-6px);
        }

        .feature-icon {
          font-size: 28px;
          color: #1fa5a9;
        }
      `}</style>
    </section>

      <SimpleProcess />
        
       <LoanCalculator />
      <EligibilitySlider />

      

      </div>
  )
}

export default HomeLoan
